<template>
  <div>
    <h3>Daten Synchronisieren</h3>
    <div class="data-sync-wrapper">
      <div class="picker">
        <div @click="() => setActiveTab('cleverreach')">
          <span>Cleverreach </span>
          <span class="inline-flex"
            ><data-input name="sync" :value="isSynced" readonly type="bool"/><i
              class="fas fa-arrow-right"
            ></i
          ></span>
        </div>
      </div>
      <div class="content">
        <template v-if="activeTab == 'cleverreach'">
          <cleverreach-status
            v-for="list in applicantMailingLists"
            :key="list.id"
            :mailing-list="list"
            :applicant-id="applicantId"
            :cleverreach-status="applicantCleverreachStatus"
            class="cleverreach-status"
            @updated="refetchQueries"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
import CleverreachStatus from "../../../components/applicant/CleverreachStatus.vue";
import DataInput from "@/components/ui/DataInput";
export default {
  components: { CleverreachStatus, DataInput },
  props: {
    applicantId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeTab: "cleverreach",
      applicantCleverreachStatus: []
    };
  },
  computed: {
    isSynced() {
      for (const stat of this.applicantCleverreachStatus) {
        if (stat.active) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    setActiveTab(value) {
      this.activeTab = value;
    },
    refetchQueries() {
      this.$apollo.queries.applicantMailingLists.refetch();
      this.$apollo.queries.applicantCleverreachStatus.refetch();
    }
  },
  apollo: {
    applicantMailingLists: {
      query: gql`
        query ApplicantMailingLists {
          applicantMailingLists {
            id
            name
            cleverreachID
            stamp
            lastChanged
            lastMailing
          }
        }
      `
    },
    applicantCleverreachStatus: {
      query: gql`
        query ApplicantCleverreachStatus($applicantID: ID!) {
          applicantCleverreachStatus(applicantID: $applicantID) {
            id
            email
            imported
            bounced
            groupID
            activated
            registered
            deactivated
            lastIP
            lastLocation
            lastClient
            points
            stars
            source
            attributes
            globalAttributes
            active
            converisonRate
            openRate
            clickRate
            tags
          }
        }
      `,
      variables() {
        return {
          applicantID: this.applicantId
        };
      },
      fetchPolicy: "no-cache"
    }
  }
};
</script>
<style scoped>
.data-sync-wrapper {
  display: grid;
  grid-template-columns: 2fr 5fr;
}
.data-sync-wrapper > .picker > * {
  font-size: 1.125em;
  margin: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.bool-input {
  display: inline-block;
}
.inline-flex {
  align-items: baseline;
  gap: 20px;
}
.cleverreach-status + .cleverreach-status {
  border-top: 1px solid lightgray;
  padding-top: 20px;
}
.cleverreach-status {
  padding-bottom: 20px;
  padding-left: 20px;
}
</style>
